import graphql__7adb6893424306e564f2 from "./__generated__/SetContactPreferredLanguageDialog_contact.graphql.ts";
import graphql__c2235bbf8dcfae53900c from "./__generated__/SetContactPreferredLanguageDialogMutation.graphql.ts";import * as React from "react";
import {graphql} from "react-relay";
import Section from "../form/Section";
import Field from "../form/Field";
import Row from "../form/Row";
import Label from "../form/Label";
import * as yup from "yup";
import FormDialog from "../dialog/FormDialog";
import {useFragment, useRelayEnvironment} from "react-relay/hooks";
import {useErrorContext} from "../../contexts/ErrorContext";
import {commitMutationWithErrorHandling} from "../../helper/commitMutationWithErrorHandling";
import {useIntl} from "react-intl";

type SetContactPreferredLanguageDialogProps = {
    queryRef: any
    handleCloseDialog: () => {}
}

const SetContactPreferredLanguageDialog: React.FC<SetContactPreferredLanguageDialogProps> = (props) => {
    const intl = useIntl();

    const contact = useFragment(
        graphql__7adb6893424306e564f2,
        props.queryRef
    );

    const relayEnvironment = useRelayEnvironment();
    const {addError} = useErrorContext();

    const handleSubmission = (input) => {
        commitMutationWithErrorHandling(
            relayEnvironment,
            {
                mutation: graphql__c2235bbf8dcfae53900c,
                variables: {
                    input: {
                        id: input.id,
                        preferredLanguage: input.preferredLanguage || null
                    }
                },
                onCompleted: () => {
                    props.handleCloseDialog();
                },
                onError: () => {
                    props.handleCloseDialog();
                }
            },
            addError,
            {
                customErrorMessage: intl.formatMessage({id: 'errors.failedToSetPreferredLanguage'})
            }
        )
    }

    const initialValues = {
        id: contact.id,
        preferredLanguage: contact.preferredLanguage ?? ''
    }

    const validationSchema = yup.object().shape({
        preferredLanguage: yup.string().nullable()
    });

    return (
        <FormDialog
            handleCloseDialog={props.handleCloseDialog}
            handleSubmission={handleSubmission}
            initialValues={initialValues}
            validationSchema={validationSchema}
            headline={intl.formatMessage({id: 'dialog.SetContactPreferredLanguageDialog.headline'})}
            submitLabel={intl.formatMessage({id: 'button.save'})}
        >
            <Section>
                <Row>
                    <Label>{intl.formatMessage({id: 'contact.preferredLanguage'})}</Label>
                    <Field name="preferredLanguage" as="select" autoFocus={true}>
                        <option value="">{intl.formatMessage({id: 'dialog.SetContactPreferredLanguageDialog.noPreference'})}</option>
                        <option value="de">{intl.formatMessage({id: 'language.german'})}</option>
                        <option value="en">{intl.formatMessage({id: 'language.english'})}</option>
                    </Field>
                </Row>
            </Section>
        </FormDialog>
    )
}

export default SetContactPreferredLanguageDialog;
